import { render, staticRenderFns } from "./SpeakersSection.vue?vue&type=template&id=932b812a&scoped=true&"
import script from "./SpeakersSection.vue?vue&type=script&lang=js&"
export * from "./SpeakersSection.vue?vue&type=script&lang=js&"
import style0 from "./SpeakersSection.vue?vue&type=style&index=0&id=932b812a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932b812a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSlider } from 'vuetify/lib/components/VSlider';
installComponents(component, {VCol,VIcon,VRow,VSlider})
